module.exports = __webpack_public_path__ + "img/XinFin_network.3fcc0b71.gif";